import { render, staticRenderFns } from "./packing-plan-extra-form.vue?vue&type=template&id=45d4f7c7&scoped=true&"
import script from "./packing-plan-extra-form.vue?vue&type=script&lang=ts&"
export * from "./packing-plan-extra-form.vue?vue&type=script&lang=ts&"
import style0 from "./packing-plan-extra-form.vue?vue&type=style&index=0&id=45d4f7c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d4f7c7",
  null
  
)

export default component.exports